import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  contentTitle: {
    display: 'block',
  },
  paragraph: {
    '&:not(:last-of-type)': {
      marginBottom: 8,
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    width: '100%',
  },
}));
